// "This wasn't me" (SR-2026-10-28-02): the link sent by SMS and email when an
// authenticator app is added. It removes the app and ends every session; the
// owner then signs in with their password and a code by SMS.
import { Anchor, Button, Group, Stack, Text } from "@mantine/core";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../../api/client";
import { errorMessage } from "../../shared/session/errors";
import { FormError, Notice, Page } from "../../shared/ui/Page";

export function NotMePage() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(token ? null : t("not_me.invalid"));

  const report = async () => {
    setBusy(true);
    setError(null);
    const { response, error } = await api.POST("/auth/totp-report", { body: { token } });
    setBusy(false);
    if (response.status !== 204) return setError(errorMessage(error, t("not_me.invalid")));
    setDone(true);
  };

  return (
    <Page title={t("not_me.title")}>
      {done ? (
        <Stack gap="md" data-testid="not-me-done">
          <Notice>{t("not_me.done")}</Notice>
          <Text size="sm">{t("not_me.next")}</Text>
          <Group gap="md">
            <Anchor component={Link} to="/signin">
              {t("not_me.sign_in")}
            </Anchor>
            <Anchor component={Link} to="/forgot-password">
              {t("not_me.reset")}
            </Anchor>
          </Group>
        </Stack>
      ) : (
        <Stack gap="md">
          <Text size="sm">{t("not_me.intro")}</Text>
          <FormError message={error} />
          <Button color="red" w="fit-content" loading={busy} disabled={!token} onClick={() => void report()}>
            {t("not_me.button")}
          </Button>
          <Text size="xs" c="dimmed">
            {t("not_me.was_me")}
          </Text>
        </Stack>
      )}
    </Page>
  );
}
